const ZBAR_WASM_CDNS = [
  "/vendor/zbar-wasm/index.js",
  "https://cdn.jsdelivr.net/npm/@undecaf/zbar-wasm@0.9.15/dist/index.js",
  "https://unpkg.com/@undecaf/zbar-wasm@0.9.15/dist/index.js",
];

const BARCODE_POLYFILL_CDNS = [
  "/vendor/barcode-polyfill/index.js",
  "https://cdn.jsdelivr.net/npm/@undecaf/barcode-detector-polyfill@0.9.23/dist/index.js",
  "https://unpkg.com/@undecaf/barcode-detector-polyfill@0.9.23/dist/index.js",
];

const ZXING_UMD_CDNS = [
  "/vendor/zxing/index.min.js",
  "https://cdn.jsdelivr.net/npm/@zxing/library@0.21.3/umd/index.min.js",
  "https://unpkg.com/@zxing/library@0.21.3/umd/index.min.js",
];

const runtimeScriptPromises = {};

const loadRuntimeScript = (src) => {
  if (runtimeScriptPromises[src]) {
    return runtimeScriptPromises[src];
  }

  runtimeScriptPromises[src] = new Promise((resolve, reject) => {
    const existingScript = Array.from(document.querySelectorAll("script")).find((script) => script.src === src);
    if (existingScript) {
      if (existingScript.dataset.loaded === "true") {
        resolve();
      } else {
        existingScript.addEventListener("load", () => resolve(), { once: true });
        existingScript.addEventListener("error", () => reject(new Error(`Failed to load ${src}`)), { once: true });
      }
      return;
    }

    const script = document.createElement("script");
    script.src = src;
    // Keep execution order deterministic for scripts with global dependencies.
    script.async = false;
    script.crossOrigin = "anonymous";
    script.onload = () => {
      script.dataset.loaded = "true";
      resolve();
    };
    script.onerror = () => reject(new Error(`Failed to load ${src}`));
    document.head.appendChild(script);
  });

  return runtimeScriptPromises[src];
};

const getGlobalScriptBinding = (expression) => {
  try {
    if (typeof window.eval === "function") {
      return window.eval(expression);
    }
  } catch (error) {
    return undefined;
  }

  return undefined;
};

const loadFirstAvailableScript = async (sources) => {
  let lastError;
  for (const src of sources) {
    try {
      await loadRuntimeScript(src);
      return;
    } catch (error) {
      lastError = error;
    }
  }

  throw lastError || new Error("Unable to load required runtime script");
};

const hasGlobalBinding = (expression) => Boolean(getGlobalScriptBinding(expression));

const ensureZbarRuntime = async () => {
  if (hasGlobalBinding("typeof zbarWasm !== 'undefined'")) {
    return;
  }

  await loadFirstAvailableScript(ZBAR_WASM_CDNS);

  if (!hasGlobalBinding("typeof zbarWasm !== 'undefined'")) {
    throw new Error("zbar-wasm runtime unavailable");
  }
};

export const loadBarcodePolyfillRuntime = async () => {
  if (getBarcodePolyfillClass()) {
    return;
  }

  await ensureZbarRuntime();

  if (getBarcodePolyfillClass()) {
    return;
  }

  await loadFirstAvailableScript(BARCODE_POLYFILL_CDNS);

  if (!getBarcodePolyfillClass()) {
    throw new Error("Barcode polyfill runtime unavailable");
  }
};

export const preloadBarcodeScannerRuntime = () =>
  Promise.allSettled([
    loadBarcodePolyfillRuntime(),
    loadFirstAvailableScript(ZXING_UMD_CDNS),
  ]);

export const loadZxingRuntime = () => loadFirstAvailableScript(ZXING_UMD_CDNS);

export const getBarcodePolyfillClass = () => {
  const polyfillNamespace =
    window?.barcodeDetectorPolyfill ||
    getGlobalScriptBinding("typeof barcodeDetectorPolyfill !== 'undefined' ? barcodeDetectorPolyfill : undefined");

  return polyfillNamespace?.BarcodeDetectorPolyfill || null;
};

export const getGlobalBarcodeDetector = () => {
  if (typeof window === "undefined" || !("BarcodeDetector" in window)) {
    return null;
  }

  return window.BarcodeDetector;
};
